import {makeReducer, match} from 'web-app/util/redux';
import {type ModalState, open, close} from 'web-app/react/modals-container/types';
import {type CurriculumModeType} from 'web-app/react/child-development/curriculum-builder/hook-reducer';

import * as Actions from './actions';

/*
|----------------------------------------------------------------------------------------------------------------------
| Types
|----------------------------------------------------------------------------------------------------------------------
*/
export type CurriculumBuilderModalState = ModalState<
    | {
          mode: CurriculumModeType.New;
          institutionId: string;
      }
    | {
          mode: CurriculumModeType.Edit;
          curriculumId: string;
          institutionId: string;
      }
>;

/*
|----------------------------------------------------------------------------------------------------------------------
| Reducer
|----------------------------------------------------------------------------------------------------------------------
*/
export default makeReducer<CurriculumBuilderModalState>(
    [match(Actions.show, (_, {payload}) => open(payload)), match(Actions.hide, () => close())],
    close(),
);
